import Request from '../utilis/request';
import config from  '../config';
export function getOrders(params) {
    return Request({
        url:config.config.base_url+'/api/orders',
        method:'get',
        params: params
    })
}
export function getAdminOrders(params) {
    return Request({
        url:config.config.base_url+'/api/admin/orders',
        method:'get',
        params:params
    })
}
export function getAllOwnerOrders(params) {
    return Request({
        url:config.config.base_url+'/api/owner/orders',
        method:'get',
        params:params
    })
}
export function getPaymentRequests(params = null){
    return Request({
        url:config.config.base_url+'/api/admin/payments',
        method:'get',
        params:params
    })
}
export function getOrder(hash) {
    return Request({
        url:config.config.base_url+'/orders/'+hash,
        method: 'get',
    })
}
export function getOrdersStatuses() {
    return Request({
        url:config.config.base_url+'/api/orders/statuses',
        method: 'get',
    })
}
export function updateOrder(hash, data) {
    return Request({
        url:config.config.base_url+'/api/orders/'+hash,
        method: 'put',
        data: data
    })
}
export function cancelOrderRefund(data) {
    return Request({
        url:config.config.base_url+'/api/orders/cancel',
        method: 'post',
        data: data
    })
}
export function makeCsv(data) {
    return Request({
        url:config.config.base_url+'/api/orders/csv_generate',
        method: 'post',
        data: data
    })
}

export function refund(data) {
    return Request({
        url:config.config.base_url+'/api/orders/refund',
        method: 'post',
        data: data
    })
}

export function exportToCsv(data) {
    return Request({
        url: config.config.base_url+'/api/orders/fee_breakdown/csv',
        method:'post',
        data: data
    })
}

export function exportFeeBreakdownCsv(data) {
    return Request({
        url: config.config.base_url+'/api/orders/breakdown',
        method:'post',
        data: data
    })
}

export function recreateOrder(data) {
    return Request({
        url: config.config.base_url+'/api/order/recreate',
        method:'post',
        data: data
    })
}
export function createOrder(data) {
    return Request({
        url: config.config.base_url+'/api/orders/create',
        method:'post',
        data: data
    })
}
export function packingPdf(id){
    return Request({
        url: config.config.base_url+'/api/order/packing/'+id,
        method:'get',
        responseType: 'blob'
    })
}
export function createOrderSampleSecrete(params){
    return Request({
        url: config.config.base_url+'/api/client/order/sample/secrete',
        method:'get',
        params: params
    })
}

export function deleteOrder(id){
    return Request({
        url: config.config.base_url+'/api/order/delete/'+id,
        method:'post',
    })
}
export function syncOrder(id){
    return Request({
        url: config.config.base_url+'/api/sync/order/'+id,
        method: 'post',
    })
}
